// @flow

import { useOpenPanelAnalytics } from '../../providers'

export const useOpenPanelTrack = () => {
  const analytics: any = useOpenPanelAnalytics()

  const track = (event: string, properties: Object) => {
    analytics?.track(event, properties)
  }

  return track
}

export default useOpenPanelTrack
